export const REDIRECT_URL_STORAGE_NAME = 'REDIRECT_URL_STORAGE_NAME';
